import React, { useState } from "react";
import { detailedMenu } from "../data/mock";

const DetailedMenuPage = () => {
  const [activeTab, setActiveTab] = useState("combos");

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1
            className="text-5xl lg:text-6xl font-bold mb-4 font-geom"
            style={{ color: "#f2340a" }}
          >
            A Plus Flavor Menu
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto font-geom">
            Authentic Haitian cuisine crafted with love and
            tradition
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {["combos", "sides", "drinks"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-8 py-3 rounded-lg font-bold uppercase text-lg transition-all duration-300 font-geom ${
                activeTab === tab
                  ? "bg-orange-600 text-white shadow-lg"
                  : "bg-gray-700 text-gray-300 hover:bg-gray-600"
              }`}
              style={
                activeTab === tab
                  ? { backgroundColor: "#f2340a" }
                  : {}
              }
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>

        {/* Menu Content */}
        <div className="bg-gray-800 rounded-lg shadow-2xl overflow-hidden">
          {/* COMBOS */}
          {activeTab === "combos" && (
            <div className="p-8">
              <h2
                className="text-4xl font-bold mb-2 font-geom"
                style={{ color: "#f2340a" }}
              >
                COMBOS
              </h2>
              <p className="text-gray-400 mb-8 text-lg font-geom">
                Includes a side of rice, mac and cheese, and
                three fried plantains
              </p>
              <div className="grid md:grid-cols-2 gap-6">
                {detailedMenu.combos.map((item) => (
                  <div
                    key={item.id}
                    className="border-b-2 border-gray-600 pb-4 hover:border-orange-600 transition-colors duration-300"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="text-2xl font-bold font-geom">
                          {item.name}
                        </h3>
                        {item.specialNote && (
                          <p className="text-sm text-orange-400 italic font-geom">
                            ({item.specialNote})
                          </p>
                        )}
                      </div>
                      <span
                        className="text-2xl font-bold font-geom ml-4"
                        style={{ color: "#f2340a" }}
                      >
                        ${item.price.toFixed(2)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* SIDES */}
          {activeTab === "sides" && (
            <div className="p-8">
              <h2
                className="text-4xl font-bold mb-8 font-geom"
                style={{ color: "#f2340a" }}
              >
                SIDES
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                {detailedMenu.sides.map((item) => (
                  <div
                    key={item.id}
                    className="border-b-2 border-gray-600 pb-4 hover:border-orange-600 transition-colors duration-300"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="text-xl font-bold font-geom">
                          {item.name}
                          {item.quantity && (
                            <span> ({item.quantity})</span>
                          )}
                        </h3>
                        {item.specialNote && (
                          <p className="text-sm text-orange-400 italic font-geom">
                            ({item.specialNote})
                          </p>
                        )}
                      </div>
                      <span
                        className="text-xl font-bold font-geom ml-4"
                        style={{ color: "#f2340a" }}
                      >
                        ${item.price.toFixed(2)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* DRINKS */}
          {activeTab === "drinks" && (
            <div className="p-8">
              <h2
                className="text-4xl font-bold mb-8 font-geom"
                style={{ color: "#f2340a" }}
              >
                DRINKS
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                {detailedMenu.drinks.map((item) => (
                  <div
                    key={item.id}
                    className="border-b-2 border-gray-600 pb-4 hover:border-orange-600 transition-colors duration-300"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-xl font-bold font-geom">
                        {item.name}
                      </h3>
                      <span
                        className="text-xl font-bold font-geom ml-4"
                        style={{ color: "#f2340a" }}
                      >
                        ${item.price.toFixed(2)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer Note */}
        <div className="mt-12 text-center text-gray-400 text-lg font-geom">
          <p>
            Special items available on specific days. Please
            check availability before ordering.
          </p>
          <p className="mt-4 text-sm">
            Call us at{" "}
            <span
              style={{ color: "#f2340a" }}
              className="font-bold"
            >
              973-350-6522
            </span>{" "}
            for more information
          </p>
        </div>
      </div>
    </div>
  );
};

export default DetailedMenuPage;
